import React from "react";

/**
 * 음성 파형 컴포넌트
 * 피그마 기준: 좌측 12개(4x4) + 중앙 7개(높이 증가) + 우측 12개(4x4) = 31개 바
 * 색상: #C5ABFA (primary-40%)
 * border-radius: 2px
 * gap: 4px
 */
const VoiceWave: React.FC = () => {
  // 좌측 12개: 높이 4px
  const leftBars = Array(12).fill(1);
  // 중앙 7개: 높이 8, 12, 16, 20, 16, 12, 8
  const centerHeights = [2, 3, 4, 5, 4, 3, 2];
  // 우측 12개: 높이 4px
  const rightBars = Array(12).fill(1);

  return (
    <div className="flex items-center justify-center gap-1 h-5">
      {/* 좌측 12개 바 */}
      {leftBars.map((_, index) => (
        <div
          key={`left-${index}`}
          className="w-1 h-1 rounded-sm bg-[#C5ABFA]"
        />
      ))}

      {/* 중앙 7개 바 */}
      {centerHeights.map((heightUnit, index) => (
        <div
          key={`center-${index}`}
          className="w-1 rounded-sm bg-[#C5ABFA]"
          style={{ height: `${heightUnit * 4}px` }}
        />
      ))}

      {/* 우측 12개 바 */}
      {rightBars.map((_, index) => (
        <div
          key={`right-${index}`}
          className="w-1 h-1 rounded-sm bg-[#C5ABFA]"
        />
      ))}
    </div>
  );
};

export default VoiceWave;
